module.exports = __webpack_public_path__ + "static/media/yaseen-overseas.1951a920.jpeg";